import { createVenue } from './venue.model';
import { createContact } from './contact.model';
import { equals } from 'ramda';

export const createAddBookingModel = ({
  activeTab             = '0',
  calendarDateId        = null,
  startDate             = '',
  endDate               = '',
  city                  = ''               ,
  country               = ''               ,
  countries             = []               ,
  selectedCountry       = null             ,
  eventName             = ''               ,
  selectedStatus        = null             ,
  dealMemo              = ''               ,
  selectedArtists       = new Set()        ,
  artistSearchString    = ''               ,
  selectedVenue         = createVenue({})  ,
  venuSearchString      = ''               ,
  selectedPromoter      = createContact({}),
  promoterSearchString  = ''               ,
  selectedContact       = createContact({}),
  contactSearchString   = ''               ,
  user                  = undefined        ,
  bookingWizard         = true             ,
}) => {
  return {
    activeTab,
    calendarDateId,
    startDate,
    endDate,
    city,
    country,
    countries,
    selectedCountry,
    eventName,
    selectedStatus,
    dealMemo,
    selectedArtists,
    artistSearchString,
    selectedVenue: createVenue(selectedVenue || {}),
    venuSearchString,
    selectedPromoter: createContact(selectedPromoter || {}),
    promoterSearchString,
    selectedContact: createContact(selectedContact || {}),
    contactSearchString,
    user,
    bookingWizard,
  }
}


export const findAddBookingTabIndex = (tab) => {
  const result = ['basic', 'venue', 'promoter', 'contact'].findIndex(equals(tab));
  return result > -1 ? `${result}` : '0';
}


// fetch(
//   "https://dev.berlin3.com/berlin3/booking.pl",
//   {
//     "credentials": "include", "headers": { "accept": "application/json, text/javascript, */*; q=0.01", "accept-language": "en-US,en;q=0.9,bn;q=0.8", "content-type": "application/x-www-form-urlencoded", "x-requested-with": "XMLHttpRequest" }, "referrer": "https://dev.berlin3.com/berlin3/index.pl?start=1;", "referrerPolicy": "no-referrer-when-downgrade",
//     "body": "notOK=false&contact_id_promoter=11251&promoter_name=David+Echeverri&promoter_address1=&promoter_city=&promoter_postalcode=&promoter_region=&promoter_country=Colombia&promoter_phone1=&promoter_phone2=&promoter_email1=david_echeverri%40hotmail.com&promoter_vat_no=&promoter_url1=&promoter_language=en&venueName=Asf+Avant+Scene&venueAddress1=1703+Route+Gournay&venueCity=Preaux&venuePostalcode=76160&venueCountry=France&venuePhone1=0232803166&venueEmail=&venueURL1=&venueCapacity=&bookingLocationID=206182&startDate=2019-05-15&endDate=2019-05-22&city=Preaux&country=Andorra&dateName=Demo+Name+2a&bookingStatusID=49&first_offer_notes=Internal+D+M&artists=%5B117%2C132%2C89%2C205%2C106%2C120%2C26%2C222%5D&calendar_date_id=4081&section=bookings&action=finish_booking_wizard_step_3&userID=117&currency=EUR", 
//     "method": "POST", "mode": "cors"
//   });
  
//   fetch("https://dev.berlin3.com/berlin3/booking.pl", {"credentials":"omit","headers":{"accept":"application/json, text/plain, */*","content-type":"application/x-www-form-urlencoded"},"referrer":"http://localhost:8080/","referrerPolicy":"no-referrer-when-downgrade",
//   "body":"notOK=false&contact_id_promoter=11170&promoter_name=David%20Echeverri&promoter_address1=&promoter_city=&promoter_postalcode=&promoter_region=&promoter_country=Colombia&promoter_phone1=&promoter_phone2=&promoter_email1=david_echeverri%40hotmail.com&promoter_vat_no=&promoter_url1=&promoter_language=&venueName=Asf%20Avant%20Scene&venueAddress1=1703%20Route%20Gournay&venueCity=Preaux&venuePostalcode=76160&venueCountry=France&venuePhone1=0232803166&venueEmail=&venueURL1=&venueCapacity=&bookingLocationID=206182&startDate=2019-05-15&endDate=2019-05-22&city=Preaux&country=Andorra&dateName=Demo%20Name%202a&bookingStatusID=&first_offer_notes=Internal%20D%20M&artists=%5B117%2C132%2C89%2C205%2C106%2C120%2C26%2C222%5D&section=bookings&action=finish_booking_wizard_step_3&userID=117&calendar_date_id=4081",
//   "method":"POST","mode":"cors"});